// @flow

export default {
  getFeatureFlags: featureFlags => `/feature_flags?names=${featureFlags.join()}`,
  logIn: () => "/oauth/token",
  logOut: () => "/oauth/revoke",
  tokenInfo: () => "/oauth/token/info",
  inquiryProcesses: () => "/inquiry_processes",
  requestPasswordReset: () => "/users/reset_password_email",
  resetPassword: () => "/users/reset_password",
  changePassword: () => "/users/change_password",
  activatePassword: () => "/users/activate",
  inquiry: (id: number) => `/inquiries/${id}`,
  company: (id: number) => `/companies/${id}`,
  getInquiryProcess: (inquiryId: number) => `/inquiries/${inquiryId}/inquiry_process/`,
  inquiryProcessBankSuggestions: (inquiryProcessId: number) =>
    `/inquiry_processes/${inquiryProcessId}/bank_suggestions`,
  getInternalPoolExtensionBanks: (inquiryProcessId: number) =>
    `/inquiry_processes/${inquiryProcessId}/internal_pool_banks`,
  actionRequests: (id: number) => `/inquiry_processes/${id}/action_requests/last`,
  actionRequestsCustomer: (id: number) => `/action_requests/${id}`,
  lastActionRequests: (id: number) => `/inquiry_processes/${id}/action_requests/last`,
  externalActionRequest: (id: number) =>
    `/inquiry_processes/${id}/action_requests/external_pool_extension`,
  internalActionRequest: (id: number) =>
    `/inquiry_processes/${id}/action_requests/internal_pool_extension`,
  getBanks: () => "/banks",
  getBankAdvisors: (bankId: number) => `/banks/${bankId}/bank_advisors`,
  openInquiryProcess: (id: number) => `/inquiry_processes/${id}/open`,
  setDateOfInterest: (inquiryProcessId: number) =>
    `/inquiry_processes/${inquiryProcessId}/date_of_interest`,
  updateBankOfferDateOfInterest: (bankOfferId: number) =>
    `/bank_offers/${bankOfferId}/date_of_interest`,
  getUserData: () => "/users/profile",
  companies: () => "/companies",
  inquiries: () => "/inquiries",
  bankAdvisorInquiries: () => "/bank_advisor/inquiries",
  getGuaranteeBank: (id: number) => `/guarantee_banks/${id}`,
  dashboardComments: (id: number) => `/inquiry_processes/${id}/comments`,
  getGuaranteeAgents: (id: number) => `/guarantee_banks/${id}/agents`,
  setGuaranteeAgent: (id: number) => `/inquiry_processes/${id}/assign`,
  rescheduleFinancingDate: (id: number) => `/inquiry_processes/${id}/reschedule`,
  confirmCall: (id: number) => `/inquiry_processes/${id}/confirm_call`,
  confirmDocuments: (id: number) => `/inquiry_processes/${id}/confirm_documents`,
  submitInterest: (id: number) => `inquiry_processes/${id}/guarantee/submit_interest`,
  submitDecision: (id: number) => `/inquiry_processes/${id}/guarantee/submit_decision`,
  activityLog: (id: number) => `/inquiry_processes/${id}/logged_activities`,
  dropInquiry: (id: number) => `/inquiry_processes/${id}/drop`,
  inviteBankAdvisor: () => "/users/bank_advisors",
  forwardInquiryToBank: (id: number) => `/inquiry_processes/${id}/bank_offers`,
  reassignBankOffer: (id: number) => `/bank_offers/${id}/reassign`,
  downloadOkpSummary: (okpUid: string) => `/okp/inquiries/${okpUid}/summary_pdf`,
  file: (id: number) => `/files/${id}`,
  fileStatus: (id: number) => `/files/${id}/status`,
  files: (id: number) => `/inquiry_processes/${id}/files`,
  filesInquiryProcess: (id: number) => `/inquiry_processes/${id}/files`,
  filesBankOffer: (id: number) => `/bank_offers/${id}/files`,
  filesRequests: (id: number) => `/inquiry_processes/${id}/file_upload_requests`,
  hints: (id: number) => `/inquiries/${id}/hints`,
  usedBanks: (id: number) => `/inquiries/${id}/used_banks`,
  bankOffers: () => "/bank_offers",
  internalPoolBanksForCustomer: (id: number) => `/inquiries/${id}/bank_suggestions/pending`,
  inquiryBankSuggestions: (id: number) => `/inquiries/${id}/bank_suggestions`,
  getCompanies: () => "/companies",
  bankOfferFiles: (id: number) => `/bank_offers/${id}/files`,
  getBankOffer: (id: number) => `/inquiries/${id}/bank_offer`,
  setStatusOpen: (id: number) => `/bank_offers/${id}/open`,
  inquiryExcludedBanks: (id: number) => `/inquiries/${id}/excluded_banks`,
  deleteInquiryExcludedBanks: ({ id, bankId }: { id: number, bankId: number }) =>
    `/inquiries/${id}/excluded_banks/${bankId}`,
  inquiryUsedBanks: (id: number) => `/inquiries/${id}/used_banks`,
  bankSuggestionContactPerson: ({ id, bankId }: { id: number, bankId: number }) =>
    `/inquiries/${id}/bank_suggestions/${bankId}/contact`,
  usedBanksContactPerson: ({ id, bankId }: { id: number, bankId: number }) =>
    `/inquiries/${id}/used_banks/${bankId}/contact`,
  setBankOfferStatusOpen: (id: number) => `/bank_offers/${id}/open`,
  setBankOfferStatusSubmitOffer: (id: number) => `/bank_offers/${id}/submit_offer`,
  setBankOfferStatusDeclineByBank: (id: number) => `/bank_offers/${id}/decline_by_bank`,
  setBankOfferStatusDeclineByCustomer: (id: number) => `/bank_offers/${id}/decline_by_customer`,
  setBankOfferStatusSubmitInterest: (id: number) => `/bank_offers/${id}/submit_interest`,
  setBankOfferStatusContractDone: (id: number) => `/bank_offers/${id}/finalize_contract`,
  bankOfferFile: (id: number) => `/bank_offers/${id}/files`,
  forwardingState: (id: number) => `/inquiry_processes/${id}/with_forwarding_state`,
  leasingAdvisorInquiries: () => "/leasing_advisor/inquiries",
  anonymizeUser: (id: number) => `/inquiries/${id}/archive_creator`,
  createFileBundle: () => `/file_bundles`,
  fileBundleStatus: (id: number) => `/file_bundles/${id}/status`,
  fileBundle: (id: number) => `/file_bundles/${id}`,
  linkWithPartnerApp: () => "/users/link_with_partner",
  authorizePartner: () => "/oauth/authorize"
};
